import { withArtDirection } from 'gatsby-plugin-image';

import { IImage } from '../components/Image/Image';
import { IGatsbyLocalImage } from '../types/gatsby';
import { IWordpressImage } from '../types/wordpress/blocks';

interface IWordpressRawImage {
  altText: string;
  mediaItemId: string;
  modified: string;
  sourceUrl: string;
  childImageSharp: {
    gatsbyImageData: {
      aspectRatio: number;
      base64: string;
      sizes: string;
      src: string;
      srcSet: string;
    };
  };
}

const checkIsWordpressImage = (
  image: IWordpressImage | IGatsbyLocalImage | IWordpressRawImage
): image is IWordpressImage => {
  return (image as IWordpressImage).localFile !== undefined;
};

const checkIsWordpressRawImage = (
  image: IWordpressImage | IGatsbyLocalImage | IWordpressRawImage
): image is IWordpressRawImage => {
  return 'localFile' in image === false && 'childImageSharp' in image === false;
};

const checkIsGatsbyLocalImage = (
  image: IWordpressImage | IGatsbyLocalImage | IWordpressRawImage
): image is IGatsbyLocalImage => {
  return 'extension' in image && 'publicURL' in image && 'localFile' in image === false && 'childImageSharp' in image === false;
};

export const serializeImageForImageComponent = ({
  alt,
  image,
}: {
  alt?: string;
  image: IWordpressImage | IGatsbyLocalImage;
}): IImage | null => {
  // // eslint-disable-next-line no-debugger
  // debugger;
  if (!image) return null;
  if (checkIsGatsbyLocalImage(image)) {
    return {
      alt: alt ||'',
      childImageSharp: image.childImageSharp,
      extension: image.extension,
      url: image.publicURL,
    };
  }
  // this one if for WP preview
  if (checkIsWordpressRawImage(image)) {
    const previewImage = image;
    return {
      ...previewImage,
      alt: previewImage.altText,
      childImageSharp: {
        gatsbyImageData: {
          height: 0.6640625,
          images: {
            fallback: {
              sizes: '(min-width: 400px) 400px, 100vw',
              src: previewImage.sourceUrl,
              srcSet: `${previewImage.sourceUrl} 2880w`,
            },
          },
          layout: 'fullWidth',
          width: 1,
        },
      },
      url: previewImage.sourceUrl,
    };
  } else if (checkIsWordpressImage(image)) {
    return {
      alt: alt || image.altText,
      childImageSharp: image.localFile.childImageSharp,
      extension:
        image.sourceUrl.split('.')[image.sourceUrl.split('.').length - 1],
      url: image.sourceUrl,
    };
  } else {
    return image;
  }
};

export const createImageWithArtDirection = ({
  desktopImage,
  mobileImage,
}: {
  desktopImage: IWordpressImage | undefined | null;
  mobileImage: IWordpressImage | undefined | null;
}): IWordpressImage | undefined => {
  if (!desktopImage?.localFile?.childImageSharp?.gatsbyImageData)
    return undefined;
  if (!mobileImage?.localFile?.childImageSharp?.gatsbyImageData)
    return desktopImage;
  const desktopImgData = desktopImage.localFile.childImageSharp.gatsbyImageData;
  const mobileImgData = mobileImage.localFile.childImageSharp.gatsbyImageData;

  const imgGatsby = withArtDirection(desktopImgData, [
    {
      image: mobileImgData,
      media: '(max-width: 768px)',
    },
  ]);

  return {
    ...desktopImage,
    localFile: {
      ...desktopImage.localFile,
      childImageSharp: {
        gatsbyImageData: imgGatsby,
      },
    },
  };
};
